import React, { Component } from 'react'
import './Mensajes.css'
import { Action } from '../commons/Actions'
import Loading from '../commons/Loading'
import { auth, database, ref, get, push, set, child, onChildAdded, off, serverTimestamp } from '../../firebase'
import AuthUserContext from '../../AuthUserContext'
import moment from 'moment'
import 'moment/dist/locale/es'

moment.locale('es')

class Mensajes extends Component {
  constructor (props) {
    super(props)
    this.state = {
      msg: '',
      msgHeight: '',
      rows: [],
      loaded: false
    }
    this.handleOnChange = this.handleOnChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.getData = this.getData.bind(this)
    this.userId = auth.currentUser.uid
    this.mensajesRef = ref(database, 'grupos/mensajes')
  }
  componentDidMount () {
    this.getData(this.props.groupId)
      .then((data) => {
        const rows = []
        const groupMensajesRef = child(this.mensajesRef, this.props.groupId)
        onChildAdded(groupMensajesRef, (child) => {
          const row = {}
          row.id = child.key
          row.user = child.val().user
          row.text = child.val().msg
          row.order = child.val().sendedAt
          row.sendedAt = moment(child.val().sendedAt).fromNow()
          row.name = data[child.val().user].name
          row.photo = data[child.val().user].photo
          rows.push(row)
          rows.sort((a, b) => {
            if (a.order < b.order) {
              return 1
            }
            if (a.order > b.order) {
              return -1
            }
            return 0
          })
          this.setState({
            rows: rows
          })
        })
      })
      .catch((err) => {
        console.error(err)
      })
  }
  componentDidUpdate (prevProps) {
    if (this.props.groupId !== prevProps.groupId) {
      this.getData(this.props.groupId)
        .then((data) => {
          const rows = []
          this.db.child(this.props.groupId).on('child_added', (child) => {
            const row = {}
            row.id = child.key
            row.user = child.val().user
            row.text = child.val().msg
            row.order = child.val().sendedAt
            row.sendedAt = moment(child.val().sendedAt).fromNow()
            row.name = data[child.val().user].name
            row.photo = data[child.val().user].photo
            rows.push(row)
            rows.sort((a, b) => {
              if (a.order < b.order) {
                return 1
              }
              if (a.order > b.order) {
                return -1
              }
              return 0
            })
            this.setState({
              rows: rows
            })
          })
        })
        .catch((err) => {
          console.error(err)
        })
    }
  }
  componentWillUnmount () {
    const groupMensajesRef = child(this.mensajesRef, this.props.groupId)
    off(groupMensajesRef)
  }
  getData (groupId) {
    return new Promise((resolve, reject) => {
      this.setState({
        rows: [],
        loaded: false
      })
      const usersData = {}
      get(child(ref(database, 'grupos/miembros'), groupId))
        .then((snap) => {
          const users = []
          const promises = []
          let count = 0
          snap.forEach((child) => {
            users.push(child.key)
          })
          users.forEach((user) => {
            promises[count] = new Promise((resolve, reject) => {
              get(child(ref(database, 'usuarios/index'), user))
                .then((snap) => {
                  usersData[user] = {
                    name: snap.val().name,
                    photo: snap.val().photo
                  }
                  resolve()
                })
                .catch((err) => {
                  reject(err)
                })
            })
            count++
          })
          return Promise.all(promises)
        })
        .then(() => {
          this.setState({
            loaded: true
          })
          resolve(usersData)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
  handleOnChange (ev) {
    const height = this.textarea.scrollHeight + 2 + 'px'
    this.setState({
      msg: ev.target.value,
      msgHeight: height
    })
  }
  handleSubmit () {
    const groupMensajesRef = child(this.mensajesRef, this.props.groupId)
    const newMsgRef = push(groupMensajesRef)
    set(newMsgRef, {
      msg: this.state.msg,
      sendedAt: serverTimestamp(),
      user: this.userId
    })
      .then(() => {
        this.setState({
          msg: '',
          msgHeight: '40px'
        })
      })
      .catch((err) => {
        console.error(err)
      })
  }
  render () {
    if (this.state.loaded) {
      return (
        <div className='mensajes'>
          <div className='mensajes__control'>
            <AuthUserContext.Consumer>
              {(authUser) => (
                <div className='mensajes__control__image'>
                  <img src={authUser.user.photo} alt={authUser.user.name} />
                </div>
              )}
            </AuthUserContext.Consumer>
            <div className='mensajes__control__textarea'>
              <textarea
                placeholder='¿Qué está pasando?'
                value={this.state.msg}
                onChange={this.handleOnChange}
                ref={(el) => { this.textarea = el }}
                style={{ height: this.state.msgHeight }}
              />
              {this.state.msg !== '' ? <Action icon='send' color onClick={this.handleSubmit} /> : <Action icon='send' disabled />}
            </div>
          </div>
          {this.state.rows.length > 0 ? <div className='mensajes__list'>
            {this.state.rows.map((row) => <Row {...row} key={row.id} current={row.user === this.userId} />)}
          </div> : <div className='mensajes__list mensajes__list--empty'>
            <p>Aún no se ha compartido nada con el grupo.</p>
          </div>}
        </div>
      )
    }
    return (
      <div className='mensajes'>
        <div className='mensajes__loading'>
          <Loading />
        </div>
      </div>
    )
  }
}

const Row = (props) => {
  return (
    <div className={props.current ? 'row_mensaje row_mensaje--current' : 'row_mensaje'}>
      <div className='row_mensaje__name'>
        <p>{props.name}</p>
      </div>
      <div className='row_mensaje__group'>
        <div className='row_mensaje__image'>
          <img src={props.photo} alt={props.name} />
        </div>
        <div className='row_mensaje__body'>
          <p>{props.text}</p>
        </div>
      </div>
      <div className='row_mensaje__meta'>
        <p>{props.sendedAt}</p>
      </div>
    </div>
  )
}

export default Mensajes
